"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPageButtonsLinksLayouts = void 0;
exports.SetPageButtonsLinksLayouts = [
    "image-links",
    "card-swiper",
    "standard-buttons",
    "image-buttons-right",
    "image-buttons-left",
];
//# sourceMappingURL=ButtonLinks.js.map